export default[
    {
        path: '/ortopac',
        name:'ortoMain',
        component: () => import(/* webpackChunkName: "ortopac" */'@/views/ortopac/OrtoMain.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_ORTOPAC'],
        },

    }
]